"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var FullscreenImageWithNav = /*#__PURE__*/function () {
  function FullscreenImageWithNav(component) {
    (0, _classCallCheck2["default"])(this, FullscreenImageWithNav);
    this.dom = {
      $component: component,
      $navItems: Array.from(component.querySelectorAll('.FullscreenImageWithNav__link'))
    }, this.state = {};
    this.mouseenterItemHandler = this.mouseenterItem.bind(this);
    this.mouseleaveItemHandler = this.mouseleaveItem.bind(this);
    this.mount();
  }

  (0, _createClass2["default"])(FullscreenImageWithNav, [{
    key: "mount",
    value: function mount() {
      var _this = this;

      var self = this;
      var dom = this.dom;
      console.log('FullscreenImageWithNav : mount', this);

      if (dom.$navItems) {
        dom.$navItems.forEach(function ($el) {
          $el.addEventListener('mouseenter', _this.mouseenterItemHandler);
          $el.addEventListener('mouseleave', _this.mouseleaveItemHandler);
        });
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var self = this;
      var dom = this.dom;
      console.log('FullscreenImageWithNav : unmount', this);
    }
  }, {
    key: "mouseenterItem",
    value: function mouseenterItem(e) {
      var dom = this.dom,
          state = this.state;
      dom.$component.classList.add('FullscreenImageWithNav--hover');
    }
  }, {
    key: "mouseleaveItem",
    value: function mouseleaveItem(e) {
      var dom = this.dom,
          state = this.state;
      dom.$component.classList.remove('FullscreenImageWithNav--hover');
    }
  }]);
  return FullscreenImageWithNav;
}();

exports["default"] = FullscreenImageWithNav;